import React, { Component } from "react";
import { Grid, Box, Typography } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtBtn from "./CustomTool/CtBtn";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";

import CtDtp from "./CustomTool/CtDtp";
import {
  get_30DaysBack_FromCurrentDate,
  getLastDayofMonthofGivenDate,
  get_FirstDate_of_Given_YMD_Date,
  validatedate_min_max,
  get_YMD_from_SYS,
  get_DMY_from_YMD,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import { withRouter } from "../HOC/withRouter";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { fetchGSTDetails } from "./API";
import ExcelJS from "exceljs";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtART from "./CustomTool/ResponsiveTable";

class SalesPurchaseReport extends Component {
  state = {
    Company: [],
    Month: [],
    Purchasecolumns: [
      {
        accessorKey: "bint_srno",
        header: "Sr. No.",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_supplier",
        header: "Supplier Name",
        size: 80,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_gstin",
        header: "GST No.",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_billno",
        header: "Inv. No.",
        size: 60,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dat_purchasedateDMY",
        header: "Date",
        size: 70,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_statecode",
        header: "S. Code",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "sum(PI.dec_qty)",
        header: "Qty",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "sum(PI.dec_taxableamount)",
        header: "Amount",
        size: 70,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "vac_hsncode",
        header: "HSN",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "vac_taxname",
        header: "TAX",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "sum(PI.dec_cgstamt)",
        header: "CGST",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "sum(PI.dec_sgstamt)",
        header: "SGST",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "sum(PI.dec_igstamt)",
        header: "IGST",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "sum(PI.dec_totalamount)",
        header: "Total Amount",
        size: 70,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
    ],
    Salescolumns: [
      {
        accessorKey: "bint_srno",
        header: "Sr. No.",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_customer",
        header: "Customer Name",
        size: 80,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_gstin",
        header: "GST No.",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_billno",
        header: "Inv. No.",
        size: 60,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dat_salesdateDMY",
        header: "Date",
        size: 70,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_statecode",
        header: "S. Code",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_qty",
        header: "Qty",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "dec_taxable",
        header: "Amount",
        size: 70,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "vac_hsncode",
        header: "HSN",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_taxname",
        header: "TAX",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "dec_cgstamt",
        header: "CGST",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "dec_sgstamt",
        header: "SGST",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "dec_igstamt",
        header: "IGST",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
      {
        accessorKey: "dec_totalamt",
        header: "Total Amount",
        size: 70,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        align: "right",
        isNumeric: true,
      },
    ],
    Purchaserows: [],
    Salesrows: [],
    GSTNo: "",

    // keyColumn: [
    //   "bint_srno",
    //   "vac_CompanyName",
    //   "vac_LegderName",
    //   "vac_LegderType",
    //   "int_LegderCode",
    //   "dec_OpeningBalance",
    //   "vac_BalanceSheet",
    //   "vac_trading",
    //   "vac_profitloss",
    // ],

    formData: {
      dtpFromDate: /*  get_FirstDate_of_Given_YMD_Date(
        get_30DaysBack_FromCurrentDate()
      )*/ get_FirstDate_of_Given_YMD_Date(get_YMD_from_SYS(new Date())),
      dtpToDate:
        /* getLastDayofMonthofGivenDate(get_30DaysBack_FromCurrentDate()) */ getLastDayofMonthofGivenDate(
          get_YMD_from_SYS(new Date())
        ),
    },
    dataLoadStatus: true,
    ARD: null,
    SalesrowsCount: 0,
    SalesrowsPerPage: 50,
    PurchaserowsCount: 0,
    PurchaserowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    // document.title = "AccountSoftware : Sales Purchase";
    this.props.setActiveMenu("SalesPurchaseReport");
    // this.onFormLoad();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#endregion handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeSalesRowsPerPage = (rowsPerPage) => {
    this.setState({ SalesrowsPerPage: rowsPerPage });
  };
  handleChangePurchaseRowsPerPage = (rowsPerPage) => {
    this.setState({ PurchaserowsPerPage: rowsPerPage });
  };

  //#region handle

  //#region function

  onFormLoad = () => {
    if (this.validateFromToDate()) {
      this.props.notifyProcessing();
      let dataLoadStatus = false;
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SalesPurchaseRegister",
          dat_fromdate: this.state.formData.dtpFromDate,
          dat_todate: this.state.formData.dtpToDate,
          bint_acid: localStorage.getItem("acid"),
          bint_acyear: localStorage.getItem("ACY"),
        };
        fetchGSTDetails(reqData)
          .then((res) => {
            dataLoadStatus = true;
            let Salesrows = [],
              SalesrowsCount = 0,
              Purchaserows = [],
              PurchaserowsCount = 0,
              GSTNo = "";
            if (res.data.Sales_GST && res.data.Sales_GST.length > 0) {
              Salesrows = res.data.Sales_GST;
              SalesrowsCount = res.data.Sales_GST.length;
            }
            if (res.data.Purchase_GST && res.data.Purchase_GST.length > 0) {
              Purchaserows = res.data.Purchase_GST;
              PurchaserowsCount = res.data.Purchase_GST.length;
            }
            GSTNo = res.data.CompanyGSTNo;
            this.setState({
              dataLoadStatus,
              Salesrows,
              SalesrowsCount,
              Purchaserows,
              GSTNo,
              PurchaserowsCount,
            });
            this.props.closeUpdateProcessing();
          })
          .catch((error) => {
            console.log("Unknown error occurred in onFormLoad.", error);
          });
      });
    }
  };

  getSumOfRow = (rows, column) => {
    let Sum = 0;
    rows.map((row) => {
      Sum += Number(row[column]);
    });
    return Sum;
  };

  validateFromToDate = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;

    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else {
      result = true;
    }
    return result;
  };

  generateExcel = () => {
    const Salesrows = this.state.Salesrows.filter((row) => {
      if (row["vac_customer"] != "Total") {
        return row;
      }
    });

    const Purchaserows = this.state.Purchaserows.filter((row) => {
      if (row["vac_supplier"] != "Total") {
        return row;
      }
    });
    let SalesAmount = this.getSumOfRow(Salesrows, "dec_taxable"),
      SalesCgst = this.getSumOfRow(Salesrows, "dec_cgstamt"),
      SalesSgst = this.getSumOfRow(Salesrows, "dec_sgstamt"),
      SalesIgst = this.getSumOfRow(Salesrows, "dec_igstamt"),
      SalesTotAmt = this.getSumOfRow(Salesrows, "dec_totalamt"),
      PurchaseAmount = this.getSumOfRow(
        Purchaserows,
        "sum(PI.dec_taxableamount)"
      ),
      PurchaseCgst = this.getSumOfRow(Purchaserows, "sum(PI.dec_cgstamt)"),
      PurchaseSgst = this.getSumOfRow(Purchaserows, "sum(PI.dec_sgstamt)"),
      PurchaseIgst = this.getSumOfRow(Purchaserows, "sum(PI.dec_igstamt)"),
      PurchaseTotAmt = this.getSumOfRow(
        Purchaserows,
        "sum(PI.dec_totalamount)"
      );

    let giveBorder = (column) => {
      column.eachCell((cell) => {
        cell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };
      });
    };

    let giveColumnsCenter = (Columns) => {
      Columns.eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "left",
          wrapText: true,
        };
      });
      giveBorder(Columns);
    };

    // if (this.state.rows.length > 0) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Summary");

    worksheet.getColumn(2).width = 30;
    worksheet.getColumn(3).width = 15;
    worksheet.getColumn(5).width = 12;
    worksheet.getColumn(8).width = 20;
    worksheet.getColumn(14).width = 20;

    //#region Create Header

    let customHeadersName = [
      "Company Name : " + localStorage.getItem("CompanyName"),
    ];
    let customHeadersGST = [
      "GST No. : " + (this.state.GSTNo === null ? "" : this.state.GSTNo),
    ];
    let customHeadersDate = [
      "From Date : " +
        get_DMY_from_YMD(this.state.formData.dtpFromDate) +
        " To Date : " +
        get_DMY_from_YMD(this.state.formData.dtpToDate),
    ];
    worksheet.addRow(customHeadersName);
    worksheet.mergeCells(1, 1, 1, 13);
    worksheet.getCell(1, 1).font = {
      bold: true,
      //   size: 20,
    };
    worksheet.addRow(customHeadersGST);
    worksheet.mergeCells(2, 1, 2, 13);
    worksheet.getCell(2, 1).font = {
      bold: true,
    };
    worksheet.addRow(customHeadersDate);
    worksheet.mergeCells(3, 1, 3, 13);
    worksheet.getCell(3, 1).font = {
      bold: true,
    };

    let customHeadersSales = ["Sales Register"];
    worksheet.addRow(customHeadersSales);
    worksheet.mergeCells(4, 1, 4, 14);
    worksheet.getCell(4, 1).font = {
      bold: true,
      underline: true,
    };
    worksheet.getCell(4, 1).alignment = {
      horizontal: "center",
    };

    let HeadersSales = [
      "Sr.No",
      "Customer Name",
      "GST No.",
      "Inv. No",
      "Date",
      "S. Code",
      "Qty",
      "Amount",
      "HSN",
      "TAX",
      "CGST",
      "SGST",
      "IGST",
      "Total Amount",
    ];

    let SalesColumn = worksheet.addRow(HeadersSales);

    SalesColumn.eachCell((cell) => {
      cell.font = { bold: true };
    });

    giveBorder(SalesColumn);

    let SalesRow = [];

    console.log("this.state.Salesrows", this.state.Salesrows);
    console.log("this.state.Salescolumns", this.state.Salescolumns);

    this.state.Salesrows.forEach((row) => {
      if (row["vac_customer"] != "Total") {
        let rowData = [];
        this.state.Salescolumns.forEach((column) => {
          rowData.push(row[column.accessorKey]);
        });
        console.log("rowData", rowData);

        SalesRow = worksheet.addRow(rowData);
        SalesRow.getCell(6).value = Number(SalesRow.getCell(6).value);
        SalesRow.getCell(7).value = Number(SalesRow.getCell(7).value);
        SalesRow.getCell(8).value = Number(SalesRow.getCell(8).value);
        SalesRow.getCell(8).numFmt = "0.00";

        let cell9Value = SalesRow.getCell(9).value;
        if (!isNaN(cell9Value) && cell9Value !== null && cell9Value !== "") {
          SalesRow.getCell(9).value = Number(cell9Value);
        } else {
          SalesRow.getCell(9).value = cell9Value;
        }
        let taxCellValue = SalesRow.getCell(10).value;

        if (typeof taxCellValue === "string" && taxCellValue.includes("%")) {
          taxCellValue = Number(taxCellValue.replace("%", ""));
        } else {
          taxCellValue = taxCellValue;
        }

        SalesRow.getCell(10).value = taxCellValue;
        SalesRow.getCell(11).value = Number(SalesRow.getCell(11).value);
        SalesRow.getCell(11).numFmt = "0.00";

        SalesRow.getCell(12).value = Number(SalesRow.getCell(12).value);
        SalesRow.getCell(12).numFmt = "0.00";
        SalesRow.getCell(13).value = Number(SalesRow.getCell(13).value);
        SalesRow.getCell(13).numFmt = "0.00";
        SalesRow.getCell(14).value = Number(SalesRow.getCell(14).value);
        SalesRow.getCell(14).numFmt = "0.00";
        giveBorder(SalesRow);

        // giveColumnsCenter(SalesRow);
        SalesRow.getCell(9).alignment = { horizontal: "left" }; // CGST
      }
    });

    console.log("SalesRow", SalesRow);

    // SalesRow.eachCell((cell) => {
    //   cell.border = {
    //     top: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     left: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     bottom: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     right: { style: "thin", color: { argb: "000000" } }, // Blue color
    //   };
    // });

    // Apply right alignment for specific columns (CGST to Total Amount)

    let TotalSalesHeader = [
      "",
      "Total",
      "",
      "",
      "",
      "",
      "",
      SalesAmount,
      "",
      "",
      SalesCgst,
      SalesSgst,
      SalesIgst,
      SalesTotAmt,
    ];

    let TotalSales = worksheet.addRow(TotalSalesHeader);

    TotalSales.getCell(7).numFmt = "0.00";
    TotalSales.getCell(11).numFmt = "0.00";
    TotalSales.getCell(12).numFmt = "0.00";
    TotalSales.getCell(13).numFmt = "0.00";
    TotalSales.getCell(14).numFmt = "0.00";

    TotalSales.eachCell((cell) => {
      cell.font = { bold: true };
    });

    giveBorder(TotalSales);

    // TotalSales.eachCell((cell) => {
    //   cell.border = {
    //     top: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     left: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     bottom: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     right: { style: "thin", color: { argb: "000000" } }, // Blue color
    //   };
    // });

    worksheet.addRow();

    let customHeadersPurchase = ["Purchase Register"];
    let purchaseheading = worksheet.addRow(customHeadersPurchase);
    let purchaseheadingIndex = worksheet.getRow(purchaseheading).number._number;

    worksheet.mergeCells(purchaseheadingIndex, 1, purchaseheadingIndex, 14);

    worksheet.getCell(purchaseheadingIndex, 1).font = {
      bold: true,
    };
    worksheet.getCell(purchaseheadingIndex, 1).alignment = {
      horizontal: "center",
      underline: true,
    };

    let HeadersPurchase = [
      "Sr.No",
      "Supplier Name",
      "GST No.",
      "Inv. No",
      "Date",
      "S. Code",
      "Qty",
      "Amount",
      "HSN",
      "TAX",
      "CGST",
      "SGST",
      "IGST",
      "Total Amount",
    ];

    let PurchaseColumn = worksheet.addRow(HeadersPurchase);

    PurchaseColumn.eachCell((cell) => {
      cell.font = { bold: true };
    });

    giveBorder(PurchaseColumn);

    // PurchaseColumn.eachCell((cell) => {
    //   cell.border = {
    //     top: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     left: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     bottom: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     right: { style: "thin", color: { argb: "000000" } }, // Blue color
    //   };
    // });

    let PurchaseRow = [];

    this.state.Purchaserows.forEach((row) => {
      if (row["vac_supplier"] != "Total") {
        let rowData = [];
        this.state.Purchasecolumns.forEach((column) => {
          rowData.push(row[column.accessorKey]);
        });
        PurchaseRow = worksheet.addRow(rowData);

        PurchaseRow.getCell(6).value = Number(PurchaseRow.getCell(6).value);
        PurchaseRow.getCell(7).value = Number(PurchaseRow.getCell(7).value);
        PurchaseRow.getCell(8).value = Number(PurchaseRow.getCell(8).value);
        PurchaseRow.getCell(8).numFmt = "0.00";

        let cell9Value = PurchaseRow.getCell(9).value;
        if (!isNaN(cell9Value) && cell9Value !== null && cell9Value !== "") {
          PurchaseRow.getCell(9).value = Number(cell9Value);
        } else {
          PurchaseRow.getCell(9).value = cell9Value;
        }
        let taxCellValue = PurchaseRow.getCell(10).value;

        if (typeof taxCellValue === "string" && taxCellValue.includes("%")) {
          taxCellValue = Number(taxCellValue.replace("%", ""));
        } else {
          taxCellValue = taxCellValue;
        }

        PurchaseRow.getCell(10).value = taxCellValue;
        let cellValue = PurchaseRow.getCell(4).value;

        // cellValue = Number(cellValue.trim());

        if (isNaN(cellValue)) {
          console.error(
            "Invalid number format in cell 4:",
            PurchaseRow.getCell(4).value
          );
        } else {
          PurchaseRow.getCell(4).value = cellValue;
        }

        // PurchaseRow.getCell(11).value = Number(PurchaseRow.getCell(11).value);
        // PurchaseRow.getCell(12).value = Number(PurchaseRow.getCell(12).value);
        // PurchaseRow.getCell(13).value = Number(PurchaseRow.getCell(13).value);
        // PurchaseRow.getCell(14).value = Number(PurchaseRow.getCell(14).value);

        PurchaseRow.getCell(11).value = Number(PurchaseRow.getCell(11).value);
        PurchaseRow.getCell(11).numFmt = "0.00";

        PurchaseRow.getCell(12).value = Number(PurchaseRow.getCell(12).value);
        PurchaseRow.getCell(12).numFmt = "0.00";
        PurchaseRow.getCell(13).value = Number(PurchaseRow.getCell(13).value);
        PurchaseRow.getCell(13).numFmt = "0.00";
        PurchaseRow.getCell(14).value = Number(PurchaseRow.getCell(14).value);
        PurchaseRow.getCell(14).numFmt = "0.00";

        giveBorder(PurchaseRow);
        PurchaseRow.getCell(9).alignment = { horizontal: "left" }; // CGST
        // giveColumnsCenter(PurchaseRow);
      }
    });

    // PurchaseRow.eachCell((cell) => {
    //   cell.border = {
    //     top: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     left: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     bottom: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     right: { style: "thin", color: { argb: "000000" } }, // Blue color
    //   };
    // });

    // Supplier Return Filed in Feb 24

    let TotalPurchaseHeader = [
      "",
      "Total",
      "",
      "",
      "",
      "",
      "",
      PurchaseAmount,
      "",
      "",
      PurchaseCgst,
      PurchaseSgst,
      PurchaseIgst,
      PurchaseTotAmt,
    ];

    let TotalPurchase = worksheet.addRow(TotalPurchaseHeader);

    TotalPurchase.getCell(7).numFmt = "0.00";
    TotalPurchase.getCell(11).numFmt = "0.00";
    TotalPurchase.getCell(12).numFmt = "0.00";
    TotalPurchase.getCell(13).numFmt = "0.00";
    TotalPurchase.getCell(14).numFmt = "0.00";

    TotalPurchase.eachCell((cell) => {
      cell.font = { bold: true };
    });

    giveBorder(TotalPurchase);

    // TotalPurchase.eachCell((cell) => {
    //   cell.border = {
    //     top: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     left: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     bottom: { style: "thin", color: { argb: "000000" } }, // Blue color
    //     right: { style: "thin", color: { argb: "000000" } }, // Blue color
    //   };
    // });

    let rowNumber = TotalPurchase.number - 1;
    // worksheet.getCell(rowNumber, 15).value = "Supplier Return Filed in Feb 24";

    // Save the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "SalesPurchaseSummary.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    });
    // } else {
    //   this.props.toastErrorMsg("No Data Found");
    // }
  };

  // //#endregion function

  render() {
    // let SalesrowsCount = this.state.Salesrows.length,
    //   PurchaserowsCount = this.state.Purchaserows.length;
    return (
      <form>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Sales Purchase Report</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item style={{ display: "inline-flex" }}>
                {/* <CardContent style={{ paddingBottom: "0px" }}>
                  <CardMedia
                    component="img"
                    alt="Reset Date to Default"
                    sx={{ width: 35 }}
                    image={ResetDate}
                    onClick={() => {
                      this.setfrom_todate(true);
                    }}
                  />
                </CardContent> */}
                <CtDtp
                  id="dtpFromDate"
                  label="From Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpFromDate}
                  value={this.state.formData.dtpFromDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  nextCtrlID="dtpToDate"
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  //   defaultAction={this.openDayBookReport}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Load"
                  onClick={this.onFormLoad}
                  variant={"outlined"}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Generate Excel"
                  onClick={this.generateExcel}
                  iconName={"excel"}
                />
              </Grid>
            </Grid>
            <Grid item marginTop={3}>
              <Typography
                justifyContent={"center"}
                textAlign={"center"}
                fontSize={20}
              >
                Sales Register
              </Typography>
              {/* <TableList
                columns={this.state.Salescolumns}
                // counter={this.state.counter}
                rows={this.state.Salesrows}
                rowsCount={this.state.SalesrowsCount}
                rowsPerPage={this.state.SalesrowsPerPage}
                handleChangeRowsPerPage={this.handleChangeSalesRowsPerPage}
                //   handleOnActionClick={this.handleARDonActionClick}
                //   actionList={this.state.actionList}
                // keyColumn={this.state.keyColumn}
                //   handleOnSearchChange={this.handleOnSearchChange}
                //   searchColumns={this.state.searchColumns}
                //   searchData={this.state.searchData}
                //   provideSearch={true}
                // provideSearch={true}
                //   handleOnNewEntryClick={this.handleOnNewEntryClick}
                //   toolTipNewEntry="Sales Entry"
              /> */}

              <CtART
                rowsdata={this.state.Salesrows}
                columnsdata={this.state.Salescolumns}
                rowsPerPage={this.state.SalesrowsPerPage}
                csvFileName={csvFileName("SalesRegister")}
                // rowIconAction={[
                //   {
                //     label: "Edit",
                //     onClick: this.handleARDonActionClick_Edit,
                //     icon: "Edit",
                //     className: "secondary-button",
                //   },
                //   {
                //     label: "Delete",
                //     onClick: this.handleARDonActionClick_Delete,
                //     icon: "delete",
                //     className: "delete-button",
                //   },
                //   {
                //     label: "Print",
                //     onClick: this.openInvoiceARDSelection,
                //     icon: "print",
                //     className: "print-button",
                //   },
                // ]}
                // tableButtonAction={[
                //   {
                //     label: "Sales Entry",
                //     onClick: this.handleOnNewEntryClick,
                //     addPluseIcon: true,
                //   },
                // ]}
                // showColumnFilters={false}
                // actionColSize={110}
                hideColIdList={["mrt-row-actions"]}
                // density={"compact"}
              />
            </Grid>
            <Grid item marginTop={3}>
              <Typography
                justifyContent={"center"}
                textAlign={"center"}
                fontSize={20}
              >
                Purchase Register
              </Typography>
              <CtART
                rowsdata={this.state.Purchaserows}
                columnsdata={this.state.Purchasecolumns}
                rowsPerPage={this.state.PurchaserowsPerPage}
                csvFileName={csvFileName("SalesRegister")}
                hideColIdList={["mrt-row-actions"]}
              />
              {/* <TableList
                columns={this.state.Purchasecolumns}
                // counter={this.state.counter}
                rows={this.state.Purchaserows}
                rowsCount={this.state.PurchaserowsCount}
                rowsPerPage={this.state.PurchaserowsPerPage}
                handleChangeRowsPerPage={this.handleChangePurchaseRowsPerPage}
                //   handleOnActionClick={this.handleARDonActionClick}
                //   actionList={this.state.actionList}
                // keyColumn={this.state.keyColumn}
                //   handleOnSearchChange={this.handleOnSearchChange}
                //   searchColumns={this.state.searchColumns}
                //   searchData={this.state.searchData}
                //   provideSearch={true}
                // provideSearch={true}
                //   handleOnNewEntryClick={this.handleOnNewEntryClick}
                //   toolTipNewEntry="Sales Entry"
              /> */}
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(SalesPurchaseReport))));
